// components/Header.tsx
import React from "react";
import { LogOut } from "lucide-react";
interface HeaderProps {
  user?: {
    name: string;
    email: string;
  };
  onLogout: () => void;
}

export const Header = ({ user, onLogout }: HeaderProps) => {
  return (
    <header className="w-full bg-white shadow-sm py-3 px-6 flex items-center justify-between fixed top-0 z-10">
      <div>
        <img src="./oorjit-logo.png"  className="h-8 mr-4" />
        <h1 className={`font-sans text-xs font-medium text-black pt-1`}>Auto Connect AI</h1>
      </div>
      {user && (
        <div className="flex items-center space-x-4">
          <div className="text-right pr-5">
            <p className="font-medium text-gray-800">{user.name}</p>
            <p className="text-sm text-gray-500">{user.email}</p>
          </div>
          <button
            onClick={onLogout}
            className="text-sm text-black ml-10"
          >
            <LogOut size={20} />
          </button>
        </div>
      )}
    </header>
  );
};